import React from "react";
import EarthImage from './EarthImage';
import { motion } from 'framer-motion';

export default function Hero() {
    return (
        <>
            {/* Hero Header Section */}
            <div className="relative flex flex-col items-center justify-center text-center px-6 min-h-[95vh] bg-black text-white overflow-hidden">
            <motion.h1
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="text-4xl md:text-6xl font-bold z-10"
                >
                    Innovative <span className="text-green-400">business</span>{' '}
                    <span className="text-blue-400">solutions</span> in AFRICA.
                </motion.h1>

                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.6 }}
                    className="mt-4 text-gray-400 max-w-xl z-10"
                >
                    At Emura Group, we provide the tools and expertise to help your business thrive in today’s competitive landscape.
                </motion.p>

                <motion.button
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 1.2 }}
                    className="mt-8 px-6 py-3 bg-white text-black rounded-full font-semibold hover:bg-gray-300 transition z-10"
                >
                    Let’s talk
                </motion.button>

                {/* Sticky Globe */}
                <div className="absolute bottom-0 w-full flex justify-center z-0 pointer-events-none">
                    <div className="max-w-6xl w-full px-6">
                        <EarthImage />
                    </div>
                </div>
            </div>

            {/* Our Solutions Section */}
            <div className="flex flex-col items-center text-center px-6 pt-20 pb-10 bg-white text-black">
                <section className="mt-24 bg-white text-black rounded-3xl shadow-xl p-10 md:p-16 max-w-6xl w-full mx-auto flex flex-col md:flex-row items-center gap-10 relative">
                    <div className="flex-1 space-y-5">
                        <h2 className="text-3xl md:text-4xl font-bold">Our Solutions</h2>
                        <p className="text-gray-600">
                            Our expert consultants will work with you to develop tailored strategies that align with your business goals, ensuring sustainable growth and success.
                        </p>
                        <ul className="space-y-2 font-medium text-lg">
                            <li className="text-green-600">✔ Strategic Planning</li>
                            <li className="text-green-600">✔ Technology Integration</li>
                            <li className="text-green-600">✔ Custom Solutions</li>
                            <li className="text-green-600">✔ Performance Analytics</li>
                        </ul>
                        <button className="mt-4 text-blue-600 hover:underline font-semibold flex items-center gap-1">
                            Learn more <span className="text-xl">→</span>
                        </button>
                    </div>

                    <div className="flex-1 min-w-[300px] flex justify-center items-center">
                        <img
                            src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=800&q=80"
                            alt="Solutions visual"
                            className="w-full max-w-md rounded-2xl shadow-lg"
                        />
                    </div>

                    {/* Ambient Blurs */}
                    <div className="absolute -bottom-5 left-5 w-32 h-32 bg-yellow-300 rounded-full blur-3xl opacity-30"></div>
                    <div className="absolute -bottom-5 right-5 w-32 h-32 bg-blue-400 rounded-full blur-3xl opacity-30"></div>
                </section>
            </div>
        </>
    );
}
